module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("mone-editable")]), _vm._v(" "), _c('k-editable', {
    attrs: {
      "config": _vm.config,
      "data-list": _vm.rows
    },
    on: {
      "add-row": _vm.addNewRow,
      "del-row": _vm.delRow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eba317b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
// module id = 122
// module chunks = 1